import MapsPinIcon from '@/components/icons/maps-pin-icon';
import OrderIcon from '@/components/icons/order-icon';
import ProfileIcon from '@/components/icons/profile-icon';
import { Button } from '@/components/ui/button';
import { clearAuthCookies } from '@/lib/actions/customer/action';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';

type UserNavMobileProps = {
  token?: string;
  onClose?: () => void;
};

const NavItem = ({
  href,
  onClick,
  icon: Icon,
  label,
}: {
  href?: string;
  onClick?: () => void;
  icon: React.ComponentType<{ className: string }>;
  label: string;
}) => {
  const content = (
    <div className='flex w-full items-center justify-center'>
      <Icon className='mr-2 h-5 w-5' />
      <span className='sr-only'>{label}</span>
    </div>
  );

  return href ? (
    <Link href={href} className='flex w-full items-center justify-center'>
      {content}
    </Link>
  ) : (
    <button onClick={onClick} className='flex w-full items-center justify-center'>
      {content}
    </button>
  );
};

export function UserNavMobile({ token, onClose }: UserNavMobileProps) {
  const router = useRouter();

  const handleNavigation = (path: string) => {
    router.push(path);
    onClose?.();
  };

  const handleLogout = () => {
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
    clearAuthCookies();

    window.location.href = '/';
  };

  return (
    <div className='fixed bottom-0 z-50 mt-auto w-full border-t bg-white p-0'>
      {token ? (
        <>
          <div className='grid grid-cols-3 gap-4 border-b p-4'>
            <NavItem
              onClick={() => handleNavigation('/account')}
              icon={ProfileIcon}
              label='My Profile'
            />
            <NavItem href='/account/order' icon={OrderIcon} label='My Orders' />
            <NavItem href='/account/address' icon={MapsPinIcon} label='My Addresses' />
          </div>

          <Button
            variant='link'
            className='my-3 w-full rounded-none bg-white p-4 text-red-500'
            onClick={handleLogout}
          >
            Sign Out
          </Button>
        </>
      ) : (
        <Button
          variant='link'
          className='my-3 flex w-full items-center justify-center p-4 text-sm text-black'
          onClick={() => handleNavigation('/account/signin')}
        >
          Sign In/Sign Up
        </Button>
      )}
    </div>
  );
}
